export default __webpack_public_path__ + "static/media/PFBHealthPlanBrochure.da3c7c3c.pdf";